import { hasIn } from 'lodash';
import router from '@/router/index';

export function isDebugOn() {
  return hasIn(router, ['currentRoute', 'query', 'console']) ||
      process.env.NODE_ENV === 'development';
}

function info(...args) {
  if (isDebugOn()) {
    console.info(...args); // eslint-disable-line no-console
  }
}

function warn(...args) {
  if (isDebugOn()) {
    console.warn(...args); // eslint-disable-line no-console
  }
}

function error(...args) {
  if (isDebugOn()) {
    console.error(...args); // eslint-disable-line no-console
  }
}

export default {
  info,
  warn,
  error,
};



// WEBPACK FOOTER //
// ./src/logger.js